import React from 'react';
import { FILTER_CONFIG_NAMES } from '../../utils/DataConstants';
import WorkOrderTable from '../WorkOrderTable';

export default function WorkOrdersAllIndexPage() {
	return (
		<WorkOrderTable
			handleQueryParams
			filterConfig={{
				filters: [
					FILTER_CONFIG_NAMES.LOCATION,
					FILTER_CONFIG_NAMES.PRIORITY,
					FILTER_CONFIG_NAMES.ASSET_TYPE,
					FILTER_CONFIG_NAMES.PROBLEM_TYPE,
					FILTER_CONFIG_NAMES.SUPPLIER,
					FILTER_CONFIG_NAMES.CREATED_AT,
					FILTER_CONFIG_NAMES.COMPLETED_AT,
					FILTER_CONFIG_NAMES.IS_CAPEX,
					FILTER_CONFIG_NAMES.IS_PLANNED_MAINTENANCE,
					FILTER_CONFIG_NAMES.IS_WARRANTY,
					FILTER_CONFIG_NAMES.IS_ASSET_DOWN,
				],
			}}
		/>
	);
}
